import axios from "axios";
import { useEffect, useRef, useState } from "react";
import "./ide/ide.css";
import CodeEditor from "./ide/CodeEditor";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LanguageSelector from "./ide/LanguageSelector";
import { Button, Dropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./code.css";
import Loader from "../../../utils/loader/loader";
import ToastMessage from "../../../utils/toasts/toastMessage";
import { Link, useNavigate } from "react-router-dom";
import {
  POST_PROBLEM_STATEMENT,
  POST_UPLOAD_CODE_FILE,
} from "../../../utils/api";
import { useDispatch, useSelector } from "react-redux";
import {
  getLevelsContent,
  getSublevels,
} from "../../../Redux/coding/code.action";
import { Collapse } from "react-bootstrap";
import { apiRequest } from "../../../api/apiRequest";

const languageMapping = {
  c: "C",
  cpp: "C++",
  csharp: "C#",
  java: "Java",
  javascript: "JavaScript",
  php: "PHP",
  python: "Python",
};

const languageIcons = {
  cpp: "/assets/icons/codingIcons/C_++.png",
  java: "/assets/icons/codingIcons/java_Logo.svg",
  python: "/assets/codingIcons/python.svg",
  c: "/assets/codingIcons/C_Programming_Language.svg",
  csharp: "/assets/codingIcons/C_hash.jpg",
  javascript: "/assets/codingIcons/javascript logo.svg",
  php: "/assets/codingIcons/PHP-logo.png",
};

const languageEmoji = {
  cpp: "🧩",
  java: "☕",
  python: "🐍",
  c: "🔹",
  csharp: "♯",
  javascript: "✨",
  php: "🐘",
};

const CodingBodyNew = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [language, setLanguage] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [selectedType1, setSelectedType1] = useState("Type");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedDifficulty, setSelectedDifficulty] = useState("Difficulty");
  const [showIde, setShowIde] = useState(false);
  const [showDifficultyDropdown, setShowDifficultyDropdown] = useState(false);
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);
  const [showLevelDropdown, setShowLevelDropdown] = useState(false);
  const [showGenerateBtn, setShowGenerateBtn] = useState(false);
  const [showSolutionBtn, setShowSolutionBtn] = useState(false);
  const [challengeContent, setChallengeContent] = useState(null);
  const [questionID, setQuestionID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resourceData, setResourceData] = useState(null);

  const [isFullScreen, setIsFullScreen] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);

  const [resourceExists, setResourceExists] = useState(false);
  const [missingBugCode, setMissingBugCode] = useState("");
  const [collapseClicked, setCollapseClicked] = useState(false);
  const [showCollapseBtn, setShowCollapseBtn] = useState(false);

  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [showEditor, setShowEditor] = useState(false);
  const [fileName, setFileName] = useState("");

  const [showBackBtn, setShowBackBtn] = useState(false);
  const [levelContentData, setLevelContentData] = useState(null);

  const [menuOpen, setMenuOpen] = useState(false);
  const [openLevelId, setOpenLevelId] = useState(null);
  const [isLevelPanelOpen, setIsLevelPanelOpen] = useState(true);

  // New: track active step for gradient-border highlighting
  const [activeStep, setActiveStep] = useState("language");

  // API-related state (frontend only)
  const [langDataCache, setLangDataCache] = useState({}); // { langKey: { loading, error, data } }

  const panelRef = useRef(null);
  const toggleRef = useRef(null);

  const [panelStyle, setPanelStyle] = useState({});
  const [selectedLevelContent, setSelectedLevelContent] = useState("");
  const [showBackdrop, setShowBackdrop] = useState(true);
  const [levelChildren, setLevelChildren] = useState({});

  const [modalLevelSelected, setModalLevelSelected] = useState("");
  const [modalVersion, setModalVersion] = useState("");
  const [modalSubLevelSelected, setModalSubLevelSelected] = useState("");

  const [selectedSub, setSelectedSub] = useState(null); // condition check mark for chapters
  const [selectedChild, setSelectedChild] = useState(null); // condition check mark for sub topics

  const store = useSelector((state) => state);
  const contentStore = useSelector((state) => state?.CodeManager?.content);

  // NEW: state & handler for Code Analysis button
  const [codeAnalysisOpen, setCodeAnalysisOpen] = useState(false);
  const handleCodeAnalysisClick = () => {
    setCodeAnalysisOpen((prev) => !prev);
    setToastState({
      show: true,
      message: !codeAnalysisOpen
        ? "Code Analysis opened"
        : "Code Analysis closed",
      type: "info",
    });
  };

  useEffect(() => {
    if (contentStore) {
      setLevelContentData(contentStore);
    }
  }, [contentStore]);

  const closeEditor = () => {
    setShowIde(false);
    setCollapseClicked(false);
    setShowBackBtn(true);
  };

  const backToMainComponent = () => {
    setChallengeContent(null);
    setShowEditor(false);
    setShowIde(false);
    setShowBackBtn(false);
    setSelectedDifficulty("Difficulty");
    setSelectedType1("Type");
    setLanguage("");
    setSelectedType("");
    setShowDifficultyDropdown(false);
    setShowTypeDropdown(false);
    setShowGenerateBtn(false);
    setSelectedLevel("");
    setShowLevelDropdown(false);
    setActiveStep("language"); // reset active step
    setSelectedSub(null);
    setSelectedChild(null);
  };

  const toggleFullScreen = () => {
    setIsFullScreen((prevState) => !prevState);
  };

  useEffect(() => {
    const uploadedResource = localStorage.getItem("pdfData");
    if (uploadedResource) {
      setResourceData(uploadedResource);
    }
    // initial active step
    setActiveStep("language");
  }, []);

  const handleSelectLevel = async (e) => {
    if (!language) {
      setToastState({
        show: true,
        message: "Select a language to proceed further!",
        type: "error",
      });
      return;
    }

    const levelName = e.target.name;
    const isLevelChanged = selectedLevel && levelName !== selectedLevel;
    const isNotMisc = levelName && levelName !== "Miscellaneous";
    const isSameLevel = levelName === selectedLevel;
    const isFirstSelection = !selectedLevel;

    if (isLevelChanged) {
      setSelectedSub(null);
      setSelectedChild(null);
    }

    setLoading(true);
    try {
      if (isNotMisc || isSameLevel || isFirstSelection) {
        setMenuOpen(false);
        setOpenLevelId(null);
        setShowBackdrop(true);
        setIsLevelPanelOpen(true);

        try {
          const levelContent = await dispatch(
            getLevelsContent(language, levelName),
          );
          if (levelContent) {
            setSelectedLevel(levelName);
            levelName === "Miscellaneous"
              ? setShowTypeDropdown(true)
              : setShowTypeDropdown(false);
            // setShowTypeDropdown(true);
            setActiveStep("type");
          }
        } catch (err) {
          setToastState({
            show: true,
            message: "Failed to fetch level content",
            type: "error",
          });
        }
      } else {
        setMenuOpen(false);
        setSelectedLevel(levelName);
        levelName === "Miscellaneous"
          ? setShowTypeDropdown(true)
          : setShowTypeDropdown(false);
        // setShowTypeDropdown(true);
        setActiveStep("type");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSelectType = (e) => {
    if (!language) {
      setToastState({
        show: true,
        message: "Select a language to proceed further!",
        type: "error",
      });
      return;
    }
    const typeValue = e.target.name;
    const typeValue1 = e.target.textContent;
    if (typeValue) {
      setSelectedType(typeValue);
      setSelectedType1(typeValue1);
      setShowDifficultyDropdown(true);
      setActiveStep("difficulty");
    }
  };

  const handleSelectDifficulty = (e) => {
    if (!language) {
      setToastState({
        show: true,
        message: "Select a language to proceed further!",
        type: "error",
      });
      return;
    }
    const difficultyValue = e.target.name;
    if (difficultyValue) {
      setSelectedDifficulty(difficultyValue);
      setShowGenerateBtn(true);
      setShowSolutionBtn(false);
      setActiveStep("generate");
    }
  };

//   const handleGetResponse = async () => {
//     setLoading(true);
//     setActiveStep("generate");

//     const uploadedResource = localStorage.getItem("pdfData");

//     let queryWithoutResource = {
//       language: language,
//       problem_type: selectedType,
//       difficulty: selectedDifficulty,
//     };
//     if (resourceExists) {
//       queryWithoutResource.query = uploadedResource;
//     }
//     if (selectedLevel && selectedLevel !== "Miscellaneous") {
//       queryWithoutResource.level_type = selectedLevel;
//       queryWithoutResource.level = modalLevelSelected;
//       queryWithoutResource.sublevel = modalVersion;
//     }

//     const token = localStorage.getItem("access_token") || null;
//     const headers = {
//       Authorization: `Bearer ${token}`,
//       "Content-Type": "application/json",
//     };

//     try {
//       const resp = await axios.post(
//         POST_PROBLEM_STATEMENT,
//         queryWithoutResource,
//         {
//           headers,
//           withCredentials: true,
//         },
//       );

//       if (resp?.status === 200) {
//  setQuestionID(resp?.data?.question_id)
//         if (selectedType !== "new_code") {
//           const content = resp.data.raw_code;
         
//           setChallengeContent(content);
//           setLoading(false);
//           setMissingBugCode(selectedType);
//           setShowIde(true);
//           setShowEditor(true);
//           setShowBackBtn(true);
//         } else {
//           const content = resp.data;
//           setChallengeContent(content);
//           // setQuestionID(resp?.data?.question_id)
//           setLoading(false);
//           setShowEditor(false);
//           setShowIde(false);
//           setShowBackBtn(true);
//         }

//         setShowSolutionBtn(true);
//       } else {
//         setLoading(false);
//         setToastState({
//           show: true,
//           message: "unable to fetch response!",
//           type: "error",
//         });
//         return;
//       }
//     } catch (error) {
//       setLoading(false);
//       if (error.status === 401) {
//         setToastState({
//           show: true,
//           message:
//             error.response?.data?.detail ||
//             "unable to process request...please try later!",
//           type: "error",
//         });
//         setTimeout(() => {
//           nav("/");
//         }, 1000);
//       } else {
//         // generic error toast
//         setToastState({
//           show: true,
//           message: "Unable to process request. Try again later.",
//           type: "error",
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

const handleGetResponse = async () => {
  setLoading(true);
  setActiveStep("generate");

  // Also switched to safeGetItem — same crash risk applies to any direct
  // localStorage read, not just "access_token".
  // const uploadedResource = safeGetItem("pdfData");
  const uploadedResource = localStorage.getItem("pdfData");

  let queryWithoutResource = {
    language: language,
    problem_type: selectedType,
    difficulty: selectedDifficulty,
  };
  if (resourceExists) {
    queryWithoutResource.query = uploadedResource;
  }
  if (selectedLevel && selectedLevel !== "Miscellaneous") {
    queryWithoutResource.level_type = selectedLevel;
    queryWithoutResource.level = modalLevelSelected;
    queryWithoutResource.sublevel = modalVersion;
  }

  // No manual token/headers — apiClient's interceptor attaches Authorization
  // automatically. A 401 here is already handled globally (token cleared +
  // redirected to "/"), so we don't duplicate that navigation below.
  const result = await apiRequest("post", POST_PROBLEM_STATEMENT, queryWithoutResource);

  setLoading(false);

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "Unable to process request. Try again later.",
      type: "error",
    });
    return;
  }

  setQuestionID(result.data?.question_id);

  if (selectedType !== "new_code") {
    const content = result.data.raw_code;
    setChallengeContent(content);
    setMissingBugCode(selectedType);
    setShowIde(true);
    setShowEditor(true);
    setShowBackBtn(true);
  } else {
    const content = result.data;
    setChallengeContent(content);
    setShowEditor(false);
    setShowIde(false);
    setShowBackBtn(true);
  }

  setShowSolutionBtn(true);
};

  const uploadFile = (event) => {
    setLoading(true);
    const file = event.target.files[0];
    if (file) {
      if (
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        setPdfFile(file);
        handleResourceUpload(file);
      } else {
        setLoading(false);
        setPdfFile(null);
        setToastState({
          show: true,
          message: "Please upload a valid PDF or word document.",
          type: "error",
        });
      }
    } else {
      setLoading(false);
      setPdfFile(null);
      setToastState({
        show: true,
        message: "Please upload a file.",
        type: "error",
      });
    }
  };

  const handleClearFile = () => {
    setFileName("");
  };

  // const handleResourceUpload = async (file) => {
  //   if (!file) {
  //     setLoading(false);
  //     setToastState({
  //       show: true,
  //       message: "Please upload resource!",
  //       type: "error",
  //     });
  //     return;
  //   }
  //   const formData = new FormData();
  //   formData.append("file", file);

  //   const token = localStorage.getItem("access_token") || null;
  //   const headers = {
  //     Authorization: `Bearer ${token}`,
  //     "Content-Type": "multipart/form-data",
  //   };

  //   try {
  //     const resp = await axios.post(POST_UPLOAD_CODE_FILE, formData, {
  //       headers,
  //       withCredentials: true,
  //     });

  //     if (resp?.data) {
  //       setLoading(false);
  //       setFileName(file?.name);
  //       setToastState({
  //         show: true,
  //         message: "File uploaded!",
  //         type: "success",
  //       });
  //       localStorage.setItem("pdfData", JSON.stringify(resp?.data?.text));
  //       setResourceExists(true);
  //       setShowTypeDropdown(true);
  //       setActiveStep("type");
  //     } else {
  //       setLoading(false);
  //       setToastState({
  //         show: true,
  //         message: "Unable to fetch response!",
  //         type: "error",
  //       });
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     if (error.status === 401) {
  //       setToastState({
  //         show: true,
  //         message: error.response?.data?.detail || "Token expired.",
  //         type: "error",
  //       });
  //       setTimeout(() => {
  //         nav("/");
  //       }, 1000);
  //     } else {
  //       setToastState({
  //         show: true,
  //         message: "File upload failed. Try again.",
  //         type: "error",
  //       });
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleResourceUpload = async (file) => {
  if (!file) {
    setLoading(false);
    setToastState({
      show: true,
      message: "Please upload resource!",
      type: "error",
    });
    return;
  }

  const formData = new FormData();
  formData.append("file", file);

  // No manual token/headers — apiClient's interceptor attaches Authorization
  // automatically. Content-Type is also dropped: axios/the browser sets the
  // correct multipart boundary automatically when the body is FormData.
  // A 401 here is already handled globally (token cleared + redirected to
  // "/"), so we don't duplicate that navigation below.
  const result = await apiRequest("post", POST_UPLOAD_CODE_FILE, formData);

  setLoading(false);

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "File upload failed. Try again.",
      type: "error",
    });
    return;
  }

  setFileName(file?.name);
  setToastState({
    show: true,
    message: "File uploaded!",
    type: "success",
  });
  // Switched to a direct localStorage write here.
  localStorage.setItem("pdfData", JSON.stringify(result.data?.text));
  setResourceExists(true);
  setShowTypeDropdown(true);
  setActiveStep("type");
};

  const handleCollapseClick = () => {
    setCollapseClicked((prev) => !prev);
  };

  const onStartCoding = () => {
    setShowIde(true);
    setShowCollapseBtn(true);
    setCollapseClicked(true);
  };

  const renderLangDetails = (langKey) => {
    const cache = langDataCache[langKey];
    if (!cache) return null;
    if (cache.loading)
      return <div className="lang-meta">Loading details...</div>;
    if (cache.error)
      return <div className="lang-meta text-danger">Error: {cache.error}</div>;
    if (cache.data) {
      const { name, version, description, docsUrl } = cache.data;
      return (
        <div className="lang-meta">
          <div className="meta-line">
            <strong>{name || languageMapping[langKey] || langKey}</strong>{" "}
            {version ? `(${version})` : null}
            {docsUrl ? (
              <a
                href={docsUrl}
                target="_blank"
                rel="noreferrer"
                className="ms-2"
              >
                Docs
              </a>
            ) : null}
          </div>
          {description ? <div className="meta-desc">{description}</div> : null}
        </div>
      );
    }
    return null;
  };

  const positionPanel = () => {
    const panelEl = panelRef.current;
    const toggleEl = toggleRef.current;
    if (!panelEl || !toggleEl) return;

    const toggleRect = toggleEl.getBoundingClientRect();
    const panelRect = panelEl.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    const left = Math.min(
      Math.max(toggleRect.left + toggleRect.width / 2 - panelRect.width / 2, 8),
      Math.max(8, vw - panelRect.width - 8),
    );

    const spaceBelow = vh - toggleRect.bottom;
    const spaceAbove = toggleRect.top;
    const margin = 10;
    let top;

    if (spaceBelow >= panelRect.height + margin) {
      top = toggleRect.bottom + margin;
    } else if (spaceAbove >= panelRect.height + margin) {
      top = toggleRect.top - panelRect.height - margin;
    } else {
      top = Math.max(
        8,
        Math.min((vh - panelRect.height) / 2, vh - panelRect.height - 8),
      );
    }

    setPanelStyle({
      left: `${left}px`,
      top: `${top}px`,
      position: "fixed",
    });
  };

  useEffect(() => {
    if (!language) {
      setPanelStyle({});
      document.body.classList.remove("body--panel-open");
      return;
    }

    document.body.classList.add("body--panel-open");

    const t = setTimeout(() => positionPanel(), 0);

    const onResize = () => positionPanel();
    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", onResize, true);

    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", onResize);
      window.removeEventListener("scroll", onResize, true);
    };
  }, [language]);

  const handleSelectedLevelContent = (subLevel, version) => {
    setModalSubLevelSelected(subLevel);
    setModalVersion(version);
    setShowLevelDropdown(true);
    setSelectedLevelContent(subLevel);
    setShowBackdrop(false);
    setOpenLevelId(null);
    setIsLevelPanelOpen(false);
  };

  const fetchLevelChildren = async (levelId, label) => {
    setLoading(true);
    setModalLevelSelected(label);
    const payload = {
      lang: language,
      level: selectedLevel,
      sublevel: label,
    };
    try {
      const response = await dispatch(getSublevels(payload));
      if (
        response &&
        typeof response === "object" &&
        !Array.isArray(response)
      ) {
        const formatted = Object.entries(response).map(([key, values], i) => ({
          id: key,
          label: values,
          code: key,
        }));

        setLevelChildren((prev) => ({
          ...prev,
          [levelId]: formatted,
        }));
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.error("Failed to fetch children for", err);
    }
  };

  return (
    <section className={`w-100 code-page ${isFullScreen ? "full-screen" : ""}`}>
      <div className={`bdrs30 chat-area ${isFullScreen ? "full-screen" : ""}`}>
        <div className="title-row">
          <div className="title-row__left">
            {showBackBtn ? (
              <img
                className=""
                src="/assets/images/box-arrow-left.svg"
                alt="Back"
                onClick={backToMainComponent}
              />
            ) : (
              <span />
            )}
            <h2 className="fw900 fz28 mb-0">Coding Practice</h2>
          </div>
          <div className="title-row__right">
            <div className="mb-0 editor-header">
              {/* ========== UPDATED: Code Analysis GIF Button (public path) ========== */}
              {/* <div className="ms-2 code-analysis-wrapper">
                <button
  type="button"
  className="code-analysis-btn button"
  aria-pressed="true"
  aria-label="Code analysis"
  title="Code analysis"
  style={{
    width: "30%",
    height: "30%",
    borderRadius: "50%",
    padding: "0",
    border: "none",
    overflow: "hidden",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
  }}
>
  <img
    src="/FinalButton.gif"
    alt="Code Analysis"
    className="code-analysis-gif"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: "50%",
      display: "block",
    }}
  />
</button>

              </div> */}
              {/* ========== end replaced button ========== */}

              {/* Language Dropdown - wrapped with gradient-border */}
              <div
                className={`ms-2 ${activeStep === "language" ? "gradient-border" : ""}`}
              >
                <LanguageSelector
                  className="ms-2"
                  language={language}
                  onSelect={(lang) => {
                    setLanguage(lang);
                    setActiveStep("type");
                  }}
                />
              </div>

              {!fileName && (
                <Dropdown
                  show={menuOpen}
                  onToggle={(n) => setMenuOpen(n)}
                  autoClose="outside"
                >
                  {/* Level Dropdown - wrap toggl
                  
                  e in gradient-border when active */}
                  <div
                    className={`ms-2 ${activeStep === "type" ? "gradient-border" : ""}`}
                  >
                    <Dropdown.Toggle
                      ref={toggleRef}
                      className="dd-code"
                      id="dropdown-language"
                    >
                      {selectedLevel ? selectedLevel : "Level"}
                    </Dropdown.Toggle>
                  </div>

                  <Dropdown.Menu
                    className="lang-only-menu"
                    onClick={handleSelectLevel}
                  >
                    <Dropdown.Item
                      value="Basic"
                      name="Basic"
                      active={selectedLevel === "Basic"}
                    >
                      Basic
                    </Dropdown.Item>

                    <Dropdown.Item
                      value="Advance"
                      name="Advance"
                      active={selectedLevel === "Advance"}
                    >
                      Advance
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="Miscellaneous"
                      name="Miscellaneous"
                      active={selectedLevel === "Miscellaneous"}
                    >
                      Miscellaneous
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}

              {selectedLevelContent && selectedLevel !== "Miscellaneous" && (
                <div
                  className={`level-panel-backdrop ${!showBackdrop ? "hidden" : ""}`}
                  onClick={() => {
                    setOpenLevelId(null);
                  }}
                />
              )}

              <Collapse in={isLevelPanelOpen && !!selectedLevel}>
                <div
                  className={`level-panel ${selectedLevel ? "centered" : ""}`}
                  ref={panelRef}
                  style={panelStyle}
                >
                  {selectedLevel && selectedLevel !== "Miscellaneous" && (
                    <>
                      <div className="level-panel__header ws-style-header d-flex align-items-center justify-content-between">
                        <div className="ws-header-left d-flex align-items-center">
                          <div className="ws-icon" aria-hidden>
                            {languageIcons[language] ? (
                              <img
                                src={languageIcons[language]}
                                alt={`${language} icon`}
                              />
                            ) : (
                              <div className="emoji">
                                {languageEmoji[language] || "📘"}
                              </div>
                            )}
                          </div>

                          <div className="ws-header-text ms-3">
                            <div className="ws-title">
                              {languageMapping[language]}
                            </div>
                            <div className="ws-subtitle">
                              Choose a level to start practice or preview topics
                            </div>
                            <div className="panel-lang-details mt-1">
                              {renderLangDetails(language)}
                            </div>
                          </div>
                        </div>

                        <div className="ws-header-actions d-flex align-items-start">
                          <button
                            className="panel-close btn btn-sm"
                            onClick={() => {
                              setIsLevelPanelOpen(false);
                              setOpenLevelId(null);
                              setShowBackdrop(false);
                            }}
                            aria-label="Close"
                          >
                            ✕
                          </button>
                        </div>
                      </div>

                      <div className="levels-list mt-3">
                        {(levelContentData?.sublevels || []).map(
                          (sub, index) => {
                            const levelId = `L${index + 1}`;
                            const isOpen = openLevelId === levelId;
                            const hasChildren =
                              Array.isArray(levelChildren[levelId]) &&
                              levelChildren[levelId].length > 0;

                            return (
                              <div className="level-block mb-2" key={levelId}>
                                <button
                                  type="button"
                                  className={`level-item btn w-100 text-start ${isOpen ? "active" : "btn-light"} ${selectedSub === levelId ? "selected" : ""}`}
                                  onClick={() => {
                                    setSelectedSub(levelId);
                                    if (isOpen) {
                                      setOpenLevelId(null);
                                    } else {
                                      setOpenLevelId(levelId);

                                      if (!levelChildren[levelId]) {
                                        fetchLevelChildren(levelId, sub);
                                      }
                                    }
                                  }}
                                  aria-expanded={isOpen}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <span>
                                      {sub}{" "}
                                      {selectedSub === levelId && (
                                        <span className="ms-2">✔</span>
                                      )}{" "}
                                    </span>
                                    <span
                                      className={`caret ${isOpen ? "open" : ""}`}
                                    >
                                      ▼
                                    </span>
                                  </div>
                                </button>

                                {hasChildren && (
                                  <Collapse in={isOpen}>
                                    <div className="topics-list ps-3 mt-2">
                                      {levelChildren[levelId].map((ch) => (
                                        <button
                                          key={ch.id}
                                          type="button"
                                          className={`topic-item btn btn-sm w-100 text-start mb-1 ${selectedChild === ch.id ? "selected-child" : ""}`}
                                          onClick={() => {
                                            setShowTypeDropdown(true);
                                            setSelectedChild(ch.id);
                                            handleSelectedLevelContent(
                                              ch.label,
                                              ch.id,
                                            );
                                          }}
                                        >
                                          {`${ch.id} - ${ch.label}`}
                                        </button>
                                      ))}
                                    </div>
                                  </Collapse>
                                )}
                              </div>
                            );
                          },
                        )}
                      </div>
                    </>
                  )}
                </div>
              </Collapse>
            </div>

            {/* Type Dropdown */}
            <div
              className={`dropdown-difficulty-wrapper ${showTypeDropdown ? "fade-in" : "fade-out"}`}
            >
              {showTypeDropdown && (
                <Dropdown className="ms-2">
                  <div
                    className={`ms-0 ${activeStep === "type" || selectedType ? "" : "gradient-border"}`}
                  >
                    <Dropdown.Toggle className="dd-code" id="dropdown-type">
                      {selectedType1}
                    </Dropdown.Toggle>
                  </div>
                  <Dropdown.Menu
                    className="dd-menu"
                    onClick={(e) => handleSelectType(e)}
                  >
                    <Dropdown.Item
                      value="Bug Hunt"
                      name="bug_finding"
                      className={
                        selectedType === "bug_finding" ? "selected-type" : ""
                      }
                    >
                      Bug Hunt
                    </Dropdown.Item>
                    <p className="graytext">
                      Find out all the bugs in the code and fix them.
                    </p>

                    <Dropdown.Divider className="mb-0" />

                    <Dropdown.Item
                      value="Missing Code"
                      name="missing_code"
                      className={
                        selectedType === "missing_code" ? "selected-type" : ""
                      }
                    >
                      Missing Code
                    </Dropdown.Item>
                    <p className="graytext">
                      Fill out the missing code in the given code snippet.
                    </p>

                    <Dropdown.Divider className="mb-0" />

                    <Dropdown.Item
                      value="New Code"
                      name="new_code"
                      className={
                        selectedType === "new_code" ? "selected-type" : ""
                      }
                    >
                      New Code
                    </Dropdown.Item>
                    <p className="graytext">
                      Create a new code snippet for the given problem.
                    </p>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>

            {/* Difficulty Dropdown */}
            <div
              className={`dropdown-difficulty-wrapper ${showDifficultyDropdown ? "fade-in" : "fade-out"}`}
            >
              {showDifficultyDropdown && (
                <Dropdown>
                  <div
                    className={`${activeStep === "difficulty" ? "gradient-border" : ""}`}
                  >
                    <Dropdown.Toggle
                      className="ms-2 dd-code"
                      id="dropdown-difficulty"
                    >
                      {selectedDifficulty &&
                        selectedDifficulty.charAt(0).toUpperCase() +
                          selectedDifficulty.slice(1)}
                    </Dropdown.Toggle>
                  </div>
                  <Dropdown.Menu
                    className="dd-menu"
                    onClick={(e) => handleSelectDifficulty(e)}
                  >
                    <Dropdown.Item
                      value="easy"
                      name="Easy"
                      active={selectedDifficulty === "easy"}
                    >
                      Easy
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="medium"
                      name="Medium"
                      active={selectedDifficulty === "medium"}
                    >
                      Moderate
                    </Dropdown.Item>
                    <Dropdown.Item
                      value="hard"
                      name="Hard"
                      active={selectedDifficulty === "hard"}
                    >
                      Hard
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>

            {/* Generate Problem Button */}
            <div
              className={`dropdown-difficulty-wrapper ${showGenerateBtn ? "fade-in" : "fade-out"}`}
            >
              {showGenerateBtn && (
                <div
                  className={`ms-2 ${activeStep === "generate" ? "gradient-border fill" : "gradient-border"}`}
                >
                  <Button
                    onClick={handleGetResponse}
                    className="btn fw500 dd-code dd-code--red ms-2"
                  >
                    Generate Problem
                  </Button>
                </div>
              )}
            </div>

            <button
              className="ms-2 border-0 btn btn-solid btn-lined-dark bdrs20"
              onClick={toggleFullScreen}
            >
              {isFullScreen ? (
                <i className="fa fa-compress" aria-hidden="true" />
              ) : (
                <i className="fa fa-expand" aria-hidden="true" />
              )}
            </button>
            <button className="ms-2 btn btn-round btn-round--actions js-history-btn hide-above-768">
              <img
                src="./assets/images/inner-pages/icons/icon-history-aira-chat.svg"
                alt=""
              />
            </button>
          </div>
          <Loader show={loading} />
          <ToastMessage
            show={toastState.show}
            onClose={() =>
              setToastState({ show: false, message: "", type: "" })
            }
            message={toastState.message}
            type={toastState.type}
          />
        </div>

        {/* rest of component unchanged (challenge rendering, IDE, welcome block, etc.) */}
        <>
          <div className="mb-0 ff1 fw500 prblm-st">
            {challengeContent && challengeContent?.constraints ? (
              <>
                <div className="ff2 coding-question">
                  <div className="position-relative coding-question__gray-block">
                    {showCollapseBtn && (
                      <button
                        className={`btn btn-collapse${collapseClicked ? " clicked" : ""}`}
                        onClick={handleCollapseClick}
                      >
                        <img
                          src="./assets/images/inner-pages/icons/icon-dropdown-arrow-white.svg"
                          alt=""
                        />
                      </button>
                    )}
                    <div className="row">
                      <div className="col-12 col-lg-12">
                        <div className="fz16 fw800 ques-title">Decription</div>
                        <p className="mb-2 fw500 sub-text">
                          {challengeContent?.description}
                        </p>
                      </div>
                      <div className="col-12 col-lg-6 pe-lg-1">
                        <div className="fz16 fw800 ques-title">Input</div>
                        <ul className="mb-0" list-type="disc">
                          <li>
                            <p className="mb-2 fw400 sub-text">
                              {challengeContent?.input_format}
                            </p>
                          </li>
                        </ul>
                      </div>
                      <div className="col-12 col-lg-6 ps-lg-2">
                        <div className="fz16 fw800 ques-title">Output</div>
                        <ul className="mb-0" list-type="disc">
                          <li>
                            <p className="mb-2 fw400 sub-text">
                              {challengeContent?.output_format}
                            </p>
                          </li>
                        </ul>
                      </div>
                      <div className="col-12 col-lg-12">
                        <div className="fz16 fw800 ques-title">Constraints</div>
                        <ul className="mb-3" list-type="disc">
                          {challengeContent?.constraints?.map((c) => (
                            <li key={c}>
                              <p className="py-0 mb-0 fw400 sub-text">{c}</p>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="col-12 col-lg-12">
                        <div className="fz16 fw800 ques-title">Example</div>
                        <div className="pairs">
                          <div className="sub-text sub-text--pair">
                            <div className="fz16 fw800  label">Input</div>

                            {challengeContent?.examples?.map((e, idx) => (
                              <div className="fz16 fw400 value" key={idx}>
                                {e?.input}
                              </div>
                            ))}
                          </div>

                          <div className="sub-text sub-text--pair">
                            <div className="fz16 fw800  label">Output</div>

                            {challengeContent?.examples?.map((e, idx) => (
                              <div className="fz16 fw400 value" key={idx}>
                                {e?.output}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="prblm-st__footer">
                      {/* Replaced anchor with a button for accessibility (eslint rule satisfied) */}
                      <button
                        type="button"
                        className="ms-auto btn-solid--start"
                        onClick={(e) => {
                          e.preventDefault();
                          onStartCoding();
                        }}
                      >
                        Start Coding
                      </button>
                    </div>
                  </div>

                  <div className=" coding-question__or-block">
                    <div className="fz32 fw700 pt-0 step-num">OR</div>
                    <div className="desc">
                      <p className="mb-0 fw400">
                        Alternatively, you can upload your PDF or DOC file to
                        seamlessly start coding practice within the module. This
                        enables a personalized workflow by allowing you to code
                        directly alongside your own documents.
                      </p>
                    </div>

                    <div className="blocks__uploadPdf">
                      <div className="user-activity d-flex align-items-center gap-2">
                        <input
                          type="file"
                          className="d-none"
                          id="uploadPdf"
                          accept=".pdf, .doc, .docx"
                          onChange={uploadFile}
                        />

                        <div className="file-upload-button position-relative">
                          <label
                            htmlFor="uploadPdf"
                            className="btn border-0 custom-file-upload fw600"
                          >
                            {fileName || "Choose File"}
                          </label>

                          {fileName && (
                            <span
                              className="close-icon-inside"
                              onClick={handleClearFile}
                            >
                              ❌
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`ide-wrapper ${showIde ? "fade-in" : "fade-out"}`}
                >
                  {showIde && (
                    <div className="ide-cover">
                      <CodeEditor
                        language={language}
                        challengeContent={challengeContent}
                        questionID={questionID}
                        selectedType={selectedType}
                        onBackClick={closeEditor}
                        backToMainComponent={backToMainComponent}
                      />
                    

                    </div>
                  )}
                </div>
              </>
            ) : showEditor ? (
              <div
                className={`ide-wrapper ${showIde ? "fade-in" : "fade-out"}`}
              >
                {showIde && (
                  <div className="ide-cover">
                    <CodeEditor
                      language={language}
                      challengeContent={challengeContent}
                      questionID={questionID}
                      missingBugCode={missingBugCode}
                      selectedType={selectedType}
                      backToMainComponent={backToMainComponent}
                    />
                  </div>
                )}
              </div>
            ) : (
              <>
                <div className="welcome-block">
                  <div className="welcome-block__content">
                    <h2 className="ff2 fz28 fw800 sub-heading">
                      Welcome to the code practice module
                    </h2>
                    <p className="ff2 fz24 fw400 text-capitalize sub-text">
                      — your personalized space to sharpen programming skills
                      through hands-on challenges.
                    </p>

                    <ul className="ff2 list-inline steps-list">
                      <li>
                        <div className="step">
                          <div className="fz16 fw400 step__thumbnail step__thumbnail--yellow">
                            Step <div className="fz32 fw700 num">1</div>
                          </div>
                          <div className="desc">
                            <p className="mb-0 fw400">
                              Choose your preferred programming language, pick
                              from various problem types such as Missing Code,
                              New Code, or Bug Hunt, and select the difficulty
                              level that suits your current skillset.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="step">
                          <div className="fz16 fw400 step__thumbnail pt-0 step__thumbnail--blue">
                            <div className="fz32 fw700 num">OR</div>
                          </div>
                          <div className="desc">
                            <p className="mb-0 fw400">
                              Alternatively, you can upload your PDF or DOC file
                              to seamlessly start coding practice within the
                              module. This enables a personalized workflow by
                              allowing you to code directly alongside your own
                              documents.
                            </p>

                            {!selectedLevel && (
                              <div className="d-flex">
                                <div className="blocks__uploadPdf">
                                  <div className="user-activity d-flex align-items-center">
                                    <input
                                      type="file"
                                      className="d-none"
                                      id="uploadPdf"
                                      accept=".pdf, .doc, .docx"
                                      onChange={uploadFile}
                                    />

                                    <div className="file-upload-wrapper">
                                      <label
                                        htmlFor="uploadPdf"
                                        className="btn border-0 custom-file-upload fw600 d-flex align-items-center gap-2"
                                      >
                                        {fileName || "Choose File"}
                                      </label>

                                      {fileName && (
                                        <span
                                          className="close-icon-inside1"
                                          onClick={handleClearFile}
                                        >
                                          ❌
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="step">
                          <div className="fz16 fw400 step__thumbnail step__thumbnail--orange">
                            Step <div className="fz32 fw700 num">2</div>
                          </div>
                          <div className="desc">
                            <p className="mb-0 fw400">
                              With a wide range of tasks tailored to different
                              learning styles, this module helps you think
                              critically, debug effectively, and write efficient
                              code — one challenge at a time.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  {/* <div className="welcome-block__img">
                    <video src="assets/styles/motion graphics1.mp4" autoPlay loop muted playsInline style={{ width: "80%", height: "80%" }} />
                  </div> */}

                  <div
                    className="welcome-block__img"
                    style={{ position: "relative" }}
                  >
                    <video
                      src="assets/styles/motion graphics1.mp4"
                      autoPlay
                      loop
                      muted
                      playsInline
                      style={{ width: "80%", height: "80%" }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      </div>
      <ToastContainer />
    </section>
  );
};

export default CodingBodyNew;
